"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@ori-ui/mui-bundle/material");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _material.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M7.244 4.421A1.5 1.5 0 0 0 5 5.723v12.554a1.5 1.5 0 0 0 2.244 1.302l10.985-6.276a1.5 1.5 0 0 0 0-2.605z"
}), 'PlayFilled');
//# sourceMappingURL=index.js.map